const Config = {
  API_LOCAL_URL: process.env.REACT_APP_API_LOCAL_URL,
  API_URL: process.env.REACT_APP_API_URL,
  API_URLTEMP: process.env.REACT_APP_API_URLTEMP,
  PayUrl: process.env.REACT_APP_PayUrl,
  RepaymentUrl_Old: process.env.REACT_APP_RepaymentUrl_Old,
  RepaymentUrl: process.env.REACT_APP_RepaymentUrl,
  PFPayemntUrl: process.env.REACT_APP_PFPayemntUrl,
  ReportUrl: process.env.REACT_APP_ReportUrl,
  RPayURL: process.env.REACT_APP_RPayURL,
  AuthURL: process.env.REACT_APP_AuthURL,
  PayUrlT: process.env.REACT_APP_PayUrlT,
  RPayURLT: process.env.REACT_APP_RPayURLT,
  AuthURLT: process.env.REACT_APP_AuthURLT,
  PayUrlTP: process.env.REACT_APP_PayUrlTP,
  RPayURLTP: process.env.REACT_APP_RPayURLTP,
  AuthURLTP: process.env.REACT_APP_AuthURLTP,
  CorpCode: process.env.REACT_APP_CorpCode,
  PAYOBJECT: {
    RAZORPAYKEYNAME: process.env.REACT_APP_RAZORPAYKEYNAME,
    RAZORPAYKEYSECRET: process.env.REACT_APP_RAZORPAYKEYSECRET,
    CURRENCY: process.env.REACT_APP_CURRENCY,
    ORGANIZATION_NAME: process.env.REACT_APP_ORGANIZATION_NAME,
    ORGANIZATION_DESC: process.env.REACT_APP_ORGANIZATION_DESC,
  },
  PFamount: process.env.REACT_APP_PFAMOUNT,
  GETFILE: process.env.REACT_APP_GETFILE,
};
export default Config;
